import onConfigChange from '@/observables/config.obvervable'
import JwtHelper from '@helpers/jwt.helper'
import localforage from '@helpers/localforage.helper'
import UserHelper from '@helpers/user.helper'
import MySquid from '@interfaces/my-squid.interface'
import axios from 'axios'
import { take } from 'rxjs/operators'

export default class MainService {
  jwtHelper: JwtHelper
  userHelper: UserHelper
  localforage: any
  http: any
  config: MySquid = null
  USER_KEY = 'hub_user_session_info'
  ALLOWED_WITHOUT_USER = ['login', 'error', 'contract']

  constructor() {
    this.http = axios
    this.jwtHelper = new JwtHelper()
    this.userHelper = new UserHelper()
    this.localforage = localforage
    onConfigChange.pipe(take(1)).subscribe((config: MySquid) => {
      this.config = config
    })
  }

  async logout() {
    this.userHelper.deleteUser()
    if (!this.ALLOWED_WITHOUT_USER.includes(window.location.pathname.split('/')[1] || '') && window.location.pathname !== '/login') {
      await this.localforage.setItem('follow_link', `${window.location.pathname}${window.location.search}`)
      history.pushState({}, '', '/login')
    }
  }

  async setDefaultHeaders(additionalHeaders?: any) {
    return {
      headers: {
        ...(await this.getHeaders(additionalHeaders)),
        ...additionalHeaders,
      },
    }
  }

  async getHeaders(authorization = true, token?: string, type: any = false) {
    try {
      const headers: any = {}
      if (authorization) {
        token = token || (await this.getJWT())
        if (!token) {
          throw new Error('error_getting_token')
        }
        if (!token?.includes('Bearer')) {
          token = `Bearer ${token}`
        }
        headers.Authorization = token
      }

      if (type) {
        headers['content-type'] = type
      }
      if (this.config && this.config.organization) {
        headers['X-Sq-Community'] = `${this.config.organization._id}-${this.config._id}`
      }

      return headers
    } catch (err) {
      try {
        await this.logout()
      } catch (error) {
        console.error({ message: 'Error getting headers', error })
        await this.logout()
      }
    }
  }

  async getJWT() {
    try {
      const token = await this.localforage.getItem(this.USER_KEY)
      if (!token?.JWT) {
        throw new Error('user_token_not_found')
      }
      const JWT = token?.JWT.replace('Bearer ', '')
      if (this.jwtHelper.verifyExpirationToken(JWT)) {
        await this.logout()
        return
      }
      return JWT
    } catch (error) {
      await this.logout()
    }
  }
}
